import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'
import { ManagedDealership } from './types'

export default async function getManagedDealerships() {
    try {
        const url = `${config.API_BASE_URL}/api/v3/dealerships/?summary=true`

        const { data } = await axios.get<ManagedDealership[]>(url, {
            withCredentials: true,
            headers: defaultLosJsonHeaders(),
        })

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get managed dealerships: ${axiosError.message}`,
            axiosError,
        )

        throw axiosError
    }
}
